import isEqualWith from 'lodash/isEqualWith';

// TinyMCE rewrites the HTML it loads (e.g. wraps bare text in <p>) and reports that as a change
const rewrites = new Map();
const maxRewrites = 50;

export const rememberRewrite = (loaded, rewritten) => {
  if (loaded === rewritten) {
    return;
  }

  rewrites.delete(loaded);
  rewrites.set(loaded, rewritten);
  if (rewrites.size > maxRewrites) {
    rewrites.delete(rewrites.keys().next().value);
  }
};

const rewritten = value => rewrites.get(value) ?? value;

export const isEqualIgnoringRewrites = (a, b) => a === b || isEqualWith(a, b, (valueA, valueB) => {
  if (valueA === valueB) {
    return true;
  }

  return typeof valueA === 'string' && typeof valueB === 'string' ? rewritten(valueA) === rewritten(valueB) : undefined;
});
